import React from "react";

import Dashboard from "../components/UserDashboard/Dashboard";
// import VerifyEmail from "../components/UserDashboard/VerifyEmail";

const frontendProtectedRoutes = [
  // {
  //   path: "/verify",
  //   name: "Email Verify",
  //   exact: true,
  //   component: VerifyEmail,
  // },
  {
    path: "/profile",
    name: "Dashboard",
    exact: true,
    component: Dashboard,
  },
];
export default frontendProtectedRoutes;
